import { useNavigate, useRouteError } from 'react-router-dom'
import { ErrorDisplay } from './ErrorDisplay'

export const ErrorPage = () => {
  const error = useRouteError()
  const navigate = useNavigate()

  const is404 = error instanceof Response && error.status === 404

  const title = is404 ? 'Page not found' : 'Something went wrong'
  const description = is404
    ? "The page you're looking for doesn't exist or has been moved."
    : 'An unexpected error occurred. Please try again.'

  return (
    <ErrorDisplay
      title={title}
      description={description}
      onGoHome={() => navigate('/', { replace: true })}
    />
  )
}
